import React from 'react';

interface ICasualMockServiceProps {
  mockData: Record<string, unknown>;
  dataKey: string;
  data?: Record<string, unknown>;
  children?: React.ReactNode;
}

const CasualMockService: React.FC<ICasualMockServiceProps> = (props) => {
  const { mockData, dataKey, data = {}, children } = props;

  const injectedData = {
    ...data,
    [dataKey]: {
      data: mockData,
      loading: false,
      realLoading: false,
      errorMsg: '',
      errorType: '',
    },
    filter: {
      date_type: 'Month',
      isSingle: true,
      start_time: '',
      end_time: '',
    },
  };

  return (
    <>
      {React.Children.map(children, (child) => {
        if (React.isValidElement(child)) {
          return React.cloneElement(child, {
            data: injectedData,
            filter: injectedData.filter,
          } as Record<string, unknown>);
        }
        return child;
      })}
    </>
  );
};

export default CasualMockService;
